;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$state", "glUtils", "glToast", "creditPromotionService", "stateService", "configService", "clipboardService", "breadcrumbsService"];
  angular.module('app.core').controller('Promotion', Controller)

  /* @ngInject */
  function Controller(
    $scope,
    $state,
    glUtils,
    glToast,
    creditPromotionService,
    stateService,
    configService,
    clipboardService,
    breadcrumbsService
  ) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.onOptionChange = onOptionChange
    ctrl.onOptionAdded = onOptionAdded
    ctrl.onOptionRemoved = onOptionRemoved
    ctrl.save = save
    ctrl.getLink = getLink
    ctrl.copyLink = copyLink
    ctrl.canEditStatus = canEditStatus

    function onInit() {
      $scope.$on('$destroy', onDestroy)

      ctrl.id = $state.params.id
      ctrl.state = stateService.define(['loading', 'error', 'ready'])
      breadcrumbsService.addBreadcrumb('Promotion', 'app.promotions')

      ctrl.state.loading()
      creditPromotionService.list().then(function(promotions) {
        ctrl.promotions = promotions

        if (ctrl.id === 'new') {
          ctrl.promotion = creditPromotionService.instantiate()
          prepareOptions()
          ctrl.state.ready()
        } else {
          creditPromotionService
            .get(ctrl.id)
            .then(function(promotion) {
              ctrl.promotion = promotion
              breadcrumbsService.updateCurrentTitle(ctrl.promotion.name)
              prepareOptions()
              ctrl.state.ready()
            })
            .catch(function() {
              ctrl.state.error()
              glToast.show('Could not load promotion')
            })
        }
      })
    }

    function prepareOptions() {
      ctrl.subscriptionCodeOptions = _(ctrl.promotions)
        .uniqBy('subscriptionCode')
        .map(function(promotion) {
          return {
            label: promotion.subscriptionCode,
            value: promotion.subscriptionCode,
          }
        })
        .value()

      ctrl.durationOptions = [
        { label: 'None', value: null },
        { label: 30, value: 30 },
        { label: 90, value: 90 },
        { label: 180, value: 180 },
      ]
      if (
        ctrl.promotion.duration &&
        !_.find(ctrl.durationOptions, {
          value: ctrl.promotion.duration,
        })
      ) {
        ctrl.durationOptions.push({
          label: ctrl.promotion.duration,
          value: ctrl.promotion.duration,
        })
      }

      ctrl.maxCreditOptions = [
        { label: 3000, value: 3000 },
        { label: 5000, value: 5000 },
        { label: 10000, value: 10000 },
        { label: 20000, value: 20000 },
      ]
      if (
        ctrl.promotion.maxCredit &&
        !_.find(ctrl.maxCreditOptions, {
          value: ctrl.promotion.maxCredit,
        })
      ) {
        ctrl.maxCreditOptions.push({
          label: ctrl.promotion.maxCredit,
          value: ctrl.promotion.maxCredit,
        })
      }
    }

    function onOptionChange(value, modelKey) {
      if (!value) {
        ctrl.promotion[modelKey] = null
        return
      }

      ctrl.promotion[modelKey] = value

      if (modelKey === 'maxCredit') {
        ctrl.promotion.creditPortions = value
      }
    }

    function onOptionAdded(option, optionsKey, inputType) {
      if (inputType === 'number') {
        var value = +option.value // coerce to number
        if (!value) {
          return
        }
        option.value = value
        option.label = value
      }

      ctrl[optionsKey] = ctrl[optionsKey].concat(option)
    }

    function onOptionRemoved(option, optionsKey, modelKey) {
      ctrl[optionsKey] = _.filter(ctrl[optionsKey], function(item) {
        return item.value !== option.value
      })

      if (ctrl.promotion[modelKey] === option.value) {
        ctrl.promotion[modelKey] = null
      }
    }

    function getLink() {
      var token = ctrl.promotion.token || '<token>'
      return configService.getSubscriberPortalUrl('/signup?token=' + token)
    }

    function copyLink() {
      clipboardService.copy(getLink())
    }

    function save() {
      var wasNew = ctrl.promotion.isNew()
      ctrl.isSaving = true
      return creditPromotionService
        .save(ctrl.promotion)
        .then(function() {
          if (wasNew) {
            glUtils.changeParams({ id: ctrl.promotion.id })
          }
          glToast.show('Promotion saved')
        })
        .catch(function(error) {
          glToast.show(error.message)
        })
        .finally(function() {
          ctrl.isSaving = false
        })
    }

    function onDestroy() {
      ctrl.promotion.revert() // revert any un-saved changes
    }

    // We can only transition from `active` -> `disabled`
    // and  `pending` to `disabled`
    function canEditStatus() {
      return (
        ctrl.promotion.status === 'active' ||
        ctrl.promotion.status === 'pending'
      )
    }
  }
})()
